import { render, staticRenderFns } from "./newCenterDetail.vue?vue&type=template&id=8400a120"
import script from "./newCenterDetail.vue?vue&type=script&lang=js"
export * from "./newCenterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports